$.fn.isOnScreen = function () {
  if (this.length <= 0) {
    return false;
  }
  var win = $(window);
  var viewport = {
    top: win.scrollTop() - 200,
    left: win.scrollLeft() - 200,
  };
  viewport.right = viewport.left + win.width();
  viewport.bottom = viewport.top + win.height();
  var bounds = this.offset();
  bounds.right = bounds.left + this.outerWidth();
  bounds.bottom = bounds.top + this.outerHeight();
  return !(
    viewport.right < bounds.left ||
    viewport.left > bounds.right ||
    viewport.bottom < bounds.top ||
    viewport.top > bounds.bottom
  );
};

var keyPopup = 0;

$("[data-fancybox]").fancybox({
  afterClose: function (instance, slide) {
    keyPopup++;
    if ($("#home-featured-popup-" + keyPopup).length >= 1) {
      $("#open-featured-popup-" + keyPopup).click();
    }
  },
});
setTimeout(function () {
  $("#float-button-banner").css("bottom", "5.74vw");
}, 1000);

videojs.options.hls.overrideNative = true;
var options = {
  playbackRates: [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2],
  preload: "none",
  controlBar: {
    volumeMenuButton: {
      vertical: true,
      inline: false,
      volumeBar: {
        vertical: true,
      },
      volumeLevel: true,
    },
  },
  html5: {
    nativeAudioTracks: false,
    nativeVideoTracks: false,
  },
  flash: {
    swf: "//cdnjs.cloudflare.com/ajax/libs/videojs-swf/5.4.2/video-js.swf",
  },
  fluid: true,
};

var player = videojs("video-js", options);
player.on("contextmenu", function (e) {
  e.preventDefault();
});

jQuery("video").on("touchstart", function () {
  if (player.paused()) {
    player.play();
  } else {
    player.pause();
  }
});

$(document).on("click", ".button-play-video", function () {
  $(".container-video").css("display", "flex");
  var url = $(this).data("url");
  if ($(this).data("type") && $(this).data("type") == "youtube") {
    player.src({
      type: "video/youtube",
      src: url,
    });
  } else {
    player.src(url);
  }
  player.play();
});

$(document).on("click", ".btn-play-video-inline .thumbnail", function () {
  $(this).next().show();
  $(this).hide();
});

$(document).on("click", ".btn-close-video", function () {
  $(".container-video").hide();
  player.pause();
});

// Ready function
$(document).ready(function () {
  $(".video-js").append(
    '<a href="javascript:void(0);" class="btn-close-video"><img src="/assets/img/cancel.svg" alt="cancel.svg"></a>'
  );

  // Set the date we're counting down to
var countDownDate = new Date(new Date().setDate(new Date().getDate() + 1)).setHours(0,0,0,0);

// Update the count down every 1 second
var x = setInterval(function() {

  // Get today's date and time
  var now = new Date().getTime();

  // Find the distance between now and the count down date
  var distance = countDownDate - now;

  // Time calculations for hours, minutes, seconds, miniseconds
  var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((distance % (1000 * 60)) / 1000);
  var miniSeconds = String(1000 - new Date().getMilliseconds()).substring(0,2);
 
  $(".time .hour").html(hours >= 10 ? hours : '0' + hours)
  $(".time .minute").html(minutes >= 10 ? minutes : '0' + minutes)
  $(".time .second").html(seconds >= 10 ? seconds : '0' + seconds)
  $(".time .minisecond").html(miniSeconds >= 10 ? miniSeconds : '0' + miniSeconds)
  
  
  // If the count down is finished, write some text
  if (distance < 0) {
    clearInterval(x);
  }
}, 10);
});



const swiperRecommand = new Swiper(".recommand-swiper", {
  navigation: {
    enabled: false,
  },
  initialSlide: isMobile ? 1 : 0,
  centeredSlides: isMobile ? true : false,
  slidesPerView: isMobile ? 1.2 : 3,
  autoplay:  false,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
  },
});


const swiperApp = new Swiper(".app-swiper", {
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
    enabled: true,
  },
  slidesPerView: 1,
  autoplay: {
    delay: 3000,
    disableOnInteraction: true,
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
  },
});


var configAos = { offet: isMobile ? 100 : 500, duration: 800, delay: 300 };
AOS.init(configAos);
$(window).load(function () {
  AOS.init(configAos);
});

var _slickOptions = {
  autoplay: true,
  autoplaySpeed: 0,
  infinite: true,
  cssEase: "linear",
  arrows: false,
  slidesToScroll: 1,
  speed: 1000,
  slidesToShow: 10,
  slidesPerRow: 1,
  vertical: true,
  rows: 1,
  pauseOnHover: false,
  pauseOnFocus: false,
  useTransform: false,
  touchMove: false,
  draggable: false,
  swipe: false,
};

$(".slick-track").slick(_slickOptions);

$(document).on("click", ".tab-head-item", function(){
  const key = $(this).data('key');
  $(this).closest('.tabs').find(".tab-head-item").removeClass("active");
  $(this).closest('.tabs').find(".tab-content-item").removeClass("active");
  $("[data-key='"+key+"']").addClass("active")
})
$(document).on("click", ".tab-child-head-item", function(){
  const key = $(this).data('key');
  const tabs = $(this).closest('.tab-child');
  tabs.find(".tab-child-head-item").removeClass("active");
  tabs.find(".tab-child-content-item").removeClass("active");
  $("[data-key='"+key+"']").addClass("active")
})

// Counter
$(function () {
  var number1Id = "countNumber";

  /* Call this function with a string containing the ID name to
   * the element containing the number you want to do a count animation on.*/
  function incEltNbr(id) {
    var elt = document.getElementById(id);
    var endNbr = Number($("#" + id).data("max"));
    var speed = Number($("#" + id).data("speed"));
    var totalTime = Number($("#" + id).data("total-time"));
    incNbrRec(0, endNbr, elt, speed, totalTime);
  }

  /*A recursive function to increase the number.*/
  function incNbrRec(i, endNbr, elt, speed, totalTime) {
    if (totalTime > 0) {
      var numberIncreaseASecond = endNbr / totalTime;
      speed = 10;
     
      let c = parseFloat((numberIncreaseASecond / 50).toString())
      c = Math.round(c * 10) / 10
      i = i + c;
    }
    if (i <= endNbr) {

      let h =  new Intl.NumberFormat("en-IN").format(i);
      if(i< 10){
        h = '0' + h;
      }
      elt.innerHTML = h;
      
      setTimeout(function () {
        //Delay a bit before calling the function again.
        incNbrRec(i + 1, endNbr, elt, speed, totalTime);
      }, speed);
    } else {
      elt.innerHTML = new Intl.NumberFormat("en-IN").format(endNbr);
    }
  }
  $(document).ready(function () {
    $(window).scroll(function () {
      if (
        $("#" + number1Id).isOnScreen() &&
        $("#" + number1Id).data("is-show") != "true"
      ) {
        $("#" + number1Id).data("is-show", "true");
        incEltNbr(number1Id);
      }
    });
  });
});
